import type { SlaPlan } from '../types/help-center.types';

export const slaPlans: SlaPlan[] = [
  {
    name: 'Starter',
    price: '$49 USD/mes',
    metrics: {
      Disponibilidad: '99.0%',
      'Horas de soporte': 'Lun-Vie 9-18 BOT',
      Canal: 'Email',
      'Tiempo respuesta P1': '8 horas',
      'Tiempo respuesta P2': '24 horas',
      'Tiempo respuesta P3': '48 horas',
      'Tiempo respuesta P4': '5 días',
      'Tiempo resolución P1': '24 horas',
      'Tiempo resolución P2': '72 horas',
      'Gerente de cuenta': 'No',
      'Revisiones periodicas': 'No',
    },
  },
  {
    name: 'Professional',
    price: '$149 USD/mes',
    highlighted: true,
    metrics: {
      Disponibilidad: '99.5%',
      'Horas de soporte': 'Lun-Vie 8-20 BOT',
      Canal: 'Email + Chat',
      'Tiempo respuesta P1': '4 horas',
      'Tiempo respuesta P2': '8 horas',
      'Tiempo respuesta P3': '24 horas',
      'Tiempo respuesta P4': '48 horas',
      'Tiempo resolución P1': '8 horas',
      'Tiempo resolución P2': '24 horas',
      'Gerente de cuenta': 'No',
      'Revisiones periodicas': 'Trimestral',
    },
  },
  {
    name: 'Enterprise',
    price: 'Personalizado',
    metrics: {
      Disponibilidad: '99.9%',
      'Horas de soporte': '24/7',
      Canal: 'Email + Chat + Teléfono',
      'Tiempo respuesta P1': '1 hora',
      'Tiempo respuesta P2': '4 horas',
      'Tiempo respuesta P3': '8 horas',
      'Tiempo respuesta P4': '24 horas',
      'Tiempo resolución P1': '4 horas',
      'Tiempo resolución P2': '12 horas',
      'Gerente de cuenta': 'Dedicado',
      'Revisiones periodicas': 'Mensual',
    },
  },
];

export const priorityClassification = [
  {
    priority: 'P1',
    name: 'Critica',
    description: 'Plataforma completamente inaccesible o perdida de datos',
    example: 'Sistema caido, no se puede iniciar sesión, datos corruptos',
  },
  {
    priority: 'P2',
    name: 'Alta',
    description: 'Funcionalidad principal no operativa, sin workaround',
    example: 'No se pueden crear cotizaciones, cálculos erroneos, PDF no genera',
  },
  {
    priority: 'P3',
    name: 'Media',
    description: 'Funcionalidad degradada con workaround disponible',
    example: 'Lentitud en reportes, un filtro no funciona, error visual menor',
  },
  {
    priority: 'P4',
    name: 'Baja',
    description: 'Solicitud de mejora, pregunta, problema cosmetico',
    example: 'Sugerencia de feature, ajuste de formato, pregunta de uso',
  },
];

export const slaCredits = [
  {
    condition: '< SLA pero >= SLA - 1%',
    credit: '10%',
  },
  {
    condition: '< SLA - 1% pero >= SLA - 3%',
    credit: '25%',
  },
  {
    condition: '< SLA - 3%',
    credit: '50%',
  },
];

export const downtimeLimits = [
  {
    availability: '99.0%',
    monthlyDowntime: '7h 18min',
    yearlyDowntime: '3d 15h 36min',
  },
  {
    availability: '99.5%',
    monthlyDowntime: '3h 39min',
    yearlyDowntime: '1d 19h 48min',
  },
  {
    availability: '99.9%',
    monthlyDowntime: '43min 49s',
    yearlyDowntime: '8h 45min 56s',
  },
];
